import styled, { css } from 'styled-components';
import { themeGet, space, SpaceProps } from 'styled-system';
import { BaseButton } from 'src/kit';

export const StyledBurger = styled(BaseButton)<SpaceProps & { isOpen: boolean }>`
  width: 24px;
  ${space};

  > div {
    margin-bottom: 5px;
    height: 2px;
    background-color: ${themeGet('colors.white')};
    transition: opacity 0.35s, transform 0.35s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    :last-child {
      margin-bottom: 0;
    }

    ${props =>
      props.isOpen &&
      css`
        :first-child {
          transform: translateY(8px) rotate(45deg);
        }
        :nth-child(2) {
          opacity: 0;
        }
        :last-child {
          transform: translateY(-6px) rotate(-45deg);
        }
      `};
  }
`;
